/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type special_allocations_ParentAbsenceDTO = {
    /**
     * ChildFirstname is the child's first name
     */
    child_firstname: string;
    /**
     * ChildID is the child the absence belongs to (one of the caller's children)
     */
    child_id: string;
    /**
     * ChildLastname is the child's last name
     */
    child_lastname: string;
    /**
     * Comment is the optional note the reporter added
     */
    comment?: string;
    /**
     * CreatedAt is when the absence was reported
     */
    created_at: string;
    /**
     * FromDatetime is when the absence begins (RFC3339)
     */
    from_datetime: string;
    /**
     * FullDay reports a full-day absence
     */
    full_day: boolean;
    /**
     * ID is the absence id
     */
    id: string;
    /**
     * Reason is the absence reason
     */
    reason: special_allocations_ParentAbsenceDTO.reason;
    /**
     * ToDatetime is when the absence ends (RFC3339)
     */
    to_datetime: string;
};
export namespace special_allocations_ParentAbsenceDTO {
    /**
     * Reason is the absence reason
     */
    export enum reason {
        ILLNESS = 'ILLNESS',
        VACATION = 'VACATION',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }
}

